import React, { useState } from 'react';

import { Alert, AlertTitle } from '@mui/material';

import Button from '@/components/Buttons/Button';
import Typography from '@/components/Typography';
import KeyDialog from '@/pages/Profile/TokenGeneration/KeyDialog';

const TokenLink = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <Alert
      severity='error'
      sx={{
        backgroundColor: 'background.paper',
        color: 'text.primary',
        borderLeft: `4px solid`,
        borderColor: 'primary.main',
        py: 2,
        px: 1.5,

        '& .MuiAlert-icon': {
          color: 'primary.main',
          p: 0
        },
        '& .MuiAlert-message': {
          p: 0,
          gap: 1,
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <AlertTitle
        sx={{
          fontSize: '12px',
          m: 0,
          mt: 0.25
        }}
      >
        API access requires a token
      </AlertTitle>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 500
        }}
      >
        Create your first token in Settings to get started with API exports.{' '}
        <Button
          sx={{
            fontSize: '12px',
            fontWeight: 500,
            color: 'primary.main',
            p: 0,
            ml: 0.25
          }}
          variant='text'
          onClick={() => {
            setDialogOpen(true);
          }}
        >
          Generate token
        </Button>
      </Typography>

      <KeyDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
      />
    </Alert>
  );
};

export default TokenLink;
